import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginHorizontal: 16,
    alignSelf: 'stretch',
    marginTop: 12,
  },
  buttonText: {
    fontFamily: textStyles.regular,
    fontSize: 12,
    marginHorizontal: 8,
    color: colorPalette.raisinBlack,
  },
  buttonContainer: {
    width: undefined,
    height: undefined,
    backgroundColor: colorPalette.whiteGrey0,
    borderWidth: 1,
    borderColor: colorPalette.grey200,
    borderRadius: 12,
    paddingBottom: 4,
    paddingTop: 4,
  },
});
